import React from 'react';
import { Elements, CardElement, injectStripe } from 'react-stripe-elements';

import { CardContainer, stripeAddCardStyles } from './Styled';

export const StripeAddCard = (props) => {
  return (
    <React.Fragment>
      <Elements>
        <StripeCardForm {...props.style} renderSubmit={props.renderSubmit} />
      </Elements>
    </React.Fragment>
  );
};

const StripeCardForm = injectStripe((props) => {
  return (
    <React.Fragment>
      <CardContainer>
        <CardElement />
      </CardContainer>

      {props.renderSubmit(props.stripe)}
    </React.Fragment>
  );
});

StripeAddCard.defaultProps = {
  style: stripeAddCardStyles
};

StripeCardForm.defaultProps = {
  renderSubmit: () => null
};

export default StripeAddCard;
